module.exports = __webpack_public_path__ + "static/media/tree_unlit.99f712c4.png";